import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const getSizeClassName = bsSize => {
    return (bsSize === 'xs' && 'btn-xs') || (bsSize === 'sm' && 'btn-sm') || (bsSize === 'lg' && 'btn-lg');
};
const DropdownToggleButton = React.forwardRef((props, ref) => {
    const { id, bsSize, bsStyle, disabled, iconOnly, splitButton, className, children } = props, remainingProps = __rest(props, ["id", "bsSize", "bsStyle", "disabled", "iconOnly", "splitButton", "className", "children"]);
    const labelButtonClasses = classNames(!splitButton && 'dropdown-toggle', 'btn', `btn-${bsStyle}`, getSizeClassName(bsSize), iconOnly && 'btn-icon-only', disabled && 'disabled', className && !splitButton && className);
    return (_jsx("button", Object.assign({}, remainingProps, { id: splitButton ? `button-${id}` : id, role: 'button', type: 'button', className: labelButtonClasses, ref: ref }, { children: children })));
});
export default DropdownToggleButton;
DropdownToggleButton.propTypes = {
    disabled: PropTypes.bool,
    bsStyle: PropTypes.oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
    className: PropTypes.string,
};
